const styles = getComputedStyle(document.documentElement)

const variable = (name: string) => styles.getPropertyValue(`--${name}`)

const breakpoints = {
  sm: variable('breakpoint-sm'),
  md: variable('breakpoint-md'),
  lg: variable('breakpoint-lg'),
  xl: variable('breakpoint-xl'),
  '2xl': variable('breakpoint-2xl'),
}

export function useTailwind() {
  return {
    variable,
    breakpoints,
  }
}
